<div class="one" fxLayout="column" [formGroup]="WillEstateForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-checkbox
      fxFlex="60"
      formControlName="LETTERSOFENTITLEMENT"
      matTooltip="{{ toolTipList ? toolTipList.LETTERSOFENTITLEMENT?.HOVER : '' }}"
      [matTooltipPosition]="toolTipPostion"
    >
      Letters Of Administration?
    </mat-checkbox>
    @if (testBool && toolTipList.LETTERSOFENTITLEMENT) {
      <div fxFlex="40" class="tooltip-wrap tooltip-wrap-single">
        <input
          id="myInput"
          style="font-size: 12px"
          readonly
          disabled
          value="{{ toolTipList ? toolTipList.LETTERSOFENTITLEMENT.COPYVALUE : '' }}"
        />
        <mat-icon
          (click)="
            tooltipService.copyTooltipText(
              toolTipList
                ? $safeNavigationMigration(toolTipList?.LETTERSOFENTITLEMENT?.COPYVALUE)
                : ''
            )
          "
        >
          file_copy
        </mat-icon>
      </div>
    }
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="20"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.AGEATDEATH),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AGEATDEATH),
      }"
    >
      <mat-label>Age At Death</mat-label>
      <input
        matInput
        formControlName="AGEATDEATH"
        matTooltip="{{ toolTipList ? toolTipList.AGEATDEATH?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.AGEATDEATH) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.AGEATDEATH.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.AGEATDEATH?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFDEATH),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFDEATH),
      }"
    >
      <mat-label>Date of Death</mat-label>
      <input
        (dateInput)="DateofDeathPickerEvent('input', $event, 'DATEOFDEATH')"
        formControlName="DATEOFDEATHTEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFDEATH')"
        matInput
        name="DateofDeath"
        [matDatepicker]="DateofDeath"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFDEATH?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateofDeath"></mat-datepicker-toggle>
      <mat-datepicker #DateofDeath></mat-datepicker>
      @if (testBool && toolTipList.DATEOFDEATH) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFDEATH.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEOFDEATH?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="65"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.NAMEONDEATHCERTIFICATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.NAMEONDEATHCERTIFICATE),
      }"
    >
      <mat-label>Name On Death Certificate</mat-label>
      <input
        matInput
        formControlName="NAMEONDEATHCERTIFICATE"
        matTooltip="{{ toolTipList ? toolTipList.NAMEONDEATHCERTIFICATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.NAMEONDEATHCERTIFICATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.NAMEONDEATHCERTIFICATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.NAMEONDEATHCERTIFICATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.PLACEOFDEATH ,'has-warning':errorWarningData.Warning?.PLACEOFDEATH }">
          <mat-label>Place Of Death</mat-label>
          <textarea matInput formControlName="PLACEOFDEATH"  matTooltip="{{(toolTipList)?toolTipList.PLACEOFDEATH?.HOVER:''}}"
          [matTooltipPosition]="toolTipPostion"></textarea>
          <div  *ngIf="testBool && toolTipList.PLACEOFDEATH" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.PLACEOFDEATH.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.PLACEOFDEATH?.COPYVALUE:'')">file_copy</mat-icon></div>
        </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.PLACEOFDEATH),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.PLACEOFDEATH),
      }"
    >
      <mat-label>Place Of Death</mat-label>

      <textarea
        matInput
        formControlName="PLACEOFDEATH"
        [matTooltip]="toolTipList?.PLACEOFDEATH?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="3"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.PLACEOFDEATH) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PLACEOFDEATH.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PLACEOFDEATH?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1" [ngClass]="{'has-error':errorWarningData.Error?.ADDRESSOFDECEASED,'has-warning':errorWarningData.Warning?.ADDRESSOFDECEASED}">
        <mat-label>Address Of Deceased (if different to Will)</mat-label>
        <textarea matInput formControlName="ADDRESSOFDECEASED"  matTooltip="{{(toolTipList)?toolTipList.ADDRESSOFDECEASED?.HOVER:''}}"
        [matTooltipPosition]="toolTipPostion"></textarea>
        <div  *ngIf="testBool && toolTipList.ADDRESSOFDECEASED" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList.ADDRESSOFDECEASED.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.ADDRESSOFDECEASED?.COPYVALUE:'')">file_copy</mat-icon></div>
      </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      class="matter-textarea-wrapper pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.ADDRESSOFDECEASED),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.ADDRESSOFDECEASED),
      }"
    >
      <mat-label>Address Of Deceased (if different to Will)</mat-label>

      <textarea
        matInput
        formControlName="ADDRESSOFDECEASED"
        [matTooltip]="toolTipList?.ADDRESSOFDECEASED?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.ADDRESSOFDECEASED) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ADDRESSOFDECEASED.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ADDRESSOFDECEASED?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALASSETS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALASSETS),
        readonly_apply: islegalEstate,
      }"
    >
      <mat-label>Total Assets</mat-label>
      <input
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        style="text-align: right"
        matInput
        formControlName="TOTALASSETS"
        [readonly]="islegalEstate"
        matTooltip="{{ toolTipList ? toolTipList.TOTALASSETS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        (focusout)="focusOutAssets()"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.TOTALASSETS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TOTALASSETS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TOTALASSETS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALLIABILITIES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALLIABILITIES),
        readonly_apply: islegalEstate,
      }"
    >
      <mat-label>Total Liabilities</mat-label>
      <input
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        style="text-align: right"
        matInput
        formControlName="TOTALLIABILITIES"
        [readonly]="islegalEstate"
        matTooltip="{{ toolTipList ? toolTipList.TOTALLIABILITIES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        (focusout)="focusOutAssets()"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.TOTALLIABILITIES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TOTALLIABILITIES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.TOTALLIABILITIES?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTATENETVALUE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTATENETVALUE),
        readonly_apply: islegalEstate,
      }"
    >
      <mat-label>Net Value</mat-label>
      <input
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        style="text-align: right"
        matInput
        formControlName="ESTATENETVALUE"
        [readonly]="islegalEstate"
        matTooltip="{{ toolTipList ? toolTipList.ESTATENETVALUE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        [leadZero]="true"
      />
      @if (testBool && toolTipList.ESTATENETVALUE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ESTATENETVALUE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.ESTATENETVALUE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PROBATEGRANTNO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PROBATEGRANTNO),
      }"
    >
      <mat-label>Probate Grant No</mat-label>
      <input
        matInput
        formControlName="PROBATEGRANTNO"
        matTooltip="{{ toolTipList ? toolTipList.PROBATEGRANTNO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.PROBATEGRANTNO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PROBATEGRANTNO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PROBATEGRANTNO?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="67"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PROBATEGRANTEDTO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PROBATEGRANTEDTO),
      }"
    >
      <mat-label>Probate Granted To</mat-label>
      <input
        matInput
        formControlName="PROBATEGRANTEDTO"
        matTooltip="{{ toolTipList ? toolTipList.PROBATEGRANTEDTO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.PROBATEGRANTEDTO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PROBATEGRANTEDTO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PROBATEGRANTEDTO?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFGRANTOFREP),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFGRANTOFREP),
      }"
    >
      <mat-label>Date of Grant</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'DATEOFGRANTOFREP')"
        formControlName="DATEOFGRANTOFREPTEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFGRANTOFREP')"
        matInput
        name="DateofGrant"
        [matDatepicker]="DateofGrant"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFGRANTOFREP?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateofGrant"></mat-datepicker-toggle>
      <mat-datepicker #DateofGrant></mat-datepicker>
      @if (testBool && toolTipList.DATEOFGRANTOFREP) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFGRANTOFREP.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEOFGRANTOFREP?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="67"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BASISOFGRANT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BASISOFGRANT),
      }"
    >
      <mat-label>Basis Of Grant</mat-label>
      <input
        matInput
        formControlName="BASISOFGRANT"
        matTooltip="{{ toolTipList ? toolTipList.BASISOFGRANT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.BASISOFGRANT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BASISOFGRANT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BASISOFGRANT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PUBLISHEDIN),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PUBLISHEDIN),
      }"
    >
      <mat-label>Published In</mat-label>
      <input
        matInput
        formControlName="PUBLISHEDIN"
        matTooltip="{{ toolTipList ? toolTipList.PUBLISHEDIN?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList.PUBLISHEDIN) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PUBLISHEDIN.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PUBLISHEDIN?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PUBLISHEDDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PUBLISHEDDATE),
      }"
    >
      <mat-label>Published Date</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'PUBLISHEDDATE')"
        formControlName="PUBLISHEDDATETEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'PUBLISHEDDATE')"
        matInput
        name="PublishedDate"
        [matDatepicker]="PublishedDate"
        matTooltip="{{ toolTipList ? toolTipList.PUBLISHEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="PublishedDate"></mat-datepicker-toggle>
      <mat-datepicker #PublishedDate></mat-datepicker>
      @if (testBool && toolTipList.PUBLISHEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PUBLISHEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PUBLISHEDDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFDISTRIBUTIONNOTICE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFDISTRIBUTIONNOTICE),
      }"
    >
      <mat-label>Date Of Distribution Notice</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'DATEOFDISTRIBUTIONNOTICE')"
        formControlName="DATEOFDISTRIBUTIONNOTICETEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFDISTRIBUTIONNOTICE')"
        matInput
        name="DateOfDistribution"
        [matDatepicker]="DateOfDistribution"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFDISTRIBUTIONNOTICE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DateOfDistribution"></mat-datepicker-toggle>
      <mat-datepicker #DateOfDistribution></mat-datepicker>
      @if (testBool && toolTipList.DATEOFDISTRIBUTIONNOTICE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFDISTRIBUTIONNOTICE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEOFDISTRIBUTIONNOTICE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEOFESTATETAXRETURN),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEOFESTATETAXRETURN),
      }"
    >
      <mat-label>Date of estate tax return</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'DATEOFESTATETAXRETURN')"
        formControlName="DATEOFESTATETAXRETURNTEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'DATEOFESTATETAXRETURN')"
        matInput
        name="PublishedDate1"
        [matDatepicker]="PublishedDate1"
        matTooltip="{{ toolTipList ? toolTipList.DATEOFESTATETAXRETURN?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="PublishedDate1"></mat-datepicker-toggle>
      <mat-datepicker #PublishedDate1></mat-datepicker>
      @if (testBool && toolTipList.DATEOFESTATETAXRETURN) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEOFESTATETAXRETURN.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DATEOFESTATETAXRETURN?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTATETAXRETURNCOMPLETEDDATE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.ESTATETAXRETURNCOMPLETEDDATE
        ),
      }"
    >
      <mat-label>Estate tax return completed date</mat-label>
      <input
        (dateInput)="CommanDatePickerEvent('input', $event, 'ESTATETAXRETURNCOMPLETEDDATE')"
        formControlName="ESTATETAXRETURNCOMPLETEDDATETEXT"
        (dateChange)="CommanDatePickerEvent('change', $event, 'ESTATETAXRETURNCOMPLETEDDATE')"
        matInput
        name="PublishedDate2"
        [matDatepicker]="PublishedDate2"
        matTooltip="{{ toolTipList ? toolTipList.ESTATETAXRETURNCOMPLETEDDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="PublishedDate2"></mat-datepicker-toggle>
      <mat-datepicker #PublishedDate2></mat-datepicker>
      @if (testBool && toolTipList.ESTATETAXRETURNCOMPLETEDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ESTATETAXRETURNCOMPLETEDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ESTATETAXRETURNCOMPLETEDDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="67"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ESTATETAXRETURNSTATUS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ESTATETAXRETURNSTATUS),
      }"
    >
      <mat-label>Estate tax return status</mat-label>
      <input matInput formControlName="ESTATETAXRETURNSTATUS" />
      @if (testBool && toolTipList.ESTATETAXRETURNSTATUS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.ESTATETAXRETURNSTATUS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ESTATETAXRETURNSTATUS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
